
import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/index';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';

const appStore = createStore(
  rootReducer,
  {},
  applyMiddleware(promise, thunk)
);

export default appStore;
